import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_REWARD_REQUEST = 'Reward/FETCH_REWARD_REQUEST'
const FETCH_REWARD_SUCCESS = 'Reward/FETCH_REWARD_SUCCESS'
const FETCH_REWARD_FAILURE = 'Reward/FETCH_REWARD_FAILURE'

const FETCH_REWARD_CONDITION_REQUEST = 'Reward/FETCH_REWARD_CONDITION_REQUEST'
const FETCH_REWARD_CONDITION_SUCCESS = 'Reward/FETCH_REWARD_CONDITION_SUCCESS'
const FETCH_REWARD_CONDITION_FAILURE = 'Reward/FETCH_REWARD_CONDITION_FAILURE'

const FETCH_POINT_GAIN_REQUEST = 'Reward/FETCH_POINT_GAIN_REQUEST'
const FETCH_POINT_GAIN_SUCCESS = 'Reward/FETCH_POINT_GAIN_SUCCESS'
const FETCH_POINT_GAIN_FAILURE = 'Reward/FETCH_POINT_GAIN_FAILURE'

const FETCH_POINT_REMOVE_REQUEST = 'Reward/FETCH_POINT_REMOVE_REQUEST'
const FETCH_POINT_REMOVE_SUCCESS = 'Reward/FETCH_POINT_REMOVE_SUCCESS'
const FETCH_POINT_REMOVE_FAILURE = 'Reward/FETCH_POINT_REMOVE_FAILURE'

const FETCH_POINT_REDEEM_REQUEST = 'Reward/FETCH_POINT_REDEEM_REQUEST'
const FETCH_POINT_REDEEM_SUCCESS = 'Reward/FETCH_POINT_REDEEM_SUCCESS'
const FETCH_POINT_REDEEM_FAILURE = 'Reward/FETCH_POINT_REDEEM_FAILURE'

const FETCH_GAIN_TYPE_REQUEST = 'Reward/FETCH_GAIN_TYPE_REQUEST'
const FETCH_GAIN_TYPE_SUCCESS = 'Reward/FETCH_GAIN_TYPE_SUCCESS'
const FETCH_GAIN_TYPE_FAILURE = 'Reward/FETCH_GAIN_TYPE_FAILURE'

const FETCH_USER_REDEEM_REQUEST = 'Reward/FETCH_USER_REDEEM_REQUEST'
const FETCH_USER_REDEEM_SUCCESS = 'Reward/FETCH_USER_REDEEM_SUCCESS'
const FETCH_USER_REDEEM_FAILURE = 'Reward/FETCH_USER_REDEEM_FAILURE'

const FETCH_USER_POINT_REQUEST = 'Reward/FETCH_USER_POINT_REQUEST'
const FETCH_USER_POINT_SUCCESS = 'Reward/FETCH_USER_POINT_SUCCESS'
const FETCH_USER_POINT_FAILURE = 'Reward/FETCH_USER_POINT_FAILURE'

const CREATE_REWARD_REQUEST = 'Reward/CREATE_REWARD_REQUEST'
const CREATE_REWARD_SUCCESS = 'Reward/CREATE_REWARD_SUCCESS'
const CREATE_REWARD_FAILURE = 'Reward/CREATE_REWARD_FAILURE'

const UPDATE_REWARD_REQUEST = 'Reward/UPDATE_REWARD_REQUEST'
const UPDATE_REWARD_SUCCESS = 'Reward/UPDATE_REWARD_SUCCESS'
const UPDATE_REWARD_FAILURE = 'Reward/UPDATE_REWARD_FAILURE'

const UPDATE_REWARD_CONDITION_REQUEST = 'Reward/UPDATE_REWARD_CONDITION_REQUEST'
const UPDATE_REWARD_CONDITION_SUCCESS = 'Reward/UPDATE_REWARD_CONDITION_SUCCESS'
const UPDATE_REWARD_CONDITION_FAILURE = 'Reward/UPDATE_REWARD_CONDITION_FAILURE'

const CREATE_REWARD_CONDITION_REQUEST = 'Reward/CREATE_REWARD_CONDITION_REQUEST'
const CREATE_REWARD_CONDITION_SUCCESS = 'Reward/CREATE_REWARD_CONDITION_SUCCESS'
const CREATE_REWARD_CONDITION_FAILURE = 'Reward/CREATE_REWARD_CONDITION_FAILURE'

const UPDATE_USER_REDEEM_REQUEST = 'Reward/UPDATE_USER_REDEEM_REQUEST'
const UPDATE_USER_REDEEM_SUCCESS = 'Reward/UPDATE_USER_REDEEM_SUCCESS'
const UPDATE_USER_REDEEM_FAILURE = 'Reward/UPDATE_USER_REDEEM_FAILURE'

const UPDATE_POINT_REMOVE_REASONS_REQUEST = 'Reward/UPDATE_POINT_REMOVE_REASONS_REQUEST'
const UPDATE_POINT_REMOVE_REASONS_SUCCESS = 'Reward/UPDATE_POINT_REMOVE_REASONS_SUCCESS'
const UPDATE_POINT_REMOVE_REASONS_FAILURE = 'Reward/UPDATE_POINT_REMOVE_REASONS_FAILURE'

const CREATE_GAIN_TYPE_REQUEST = 'Reward/CREATE_GAIN_TYPE_REQUEST'
const CREATE_GAIN_TYPE_SUCCESS = 'Reward/CREATE_GAIN_TYPE_SUCCESS'
const CREATE_GAIN_TYPE_FAILURE = 'Reward/CREATE_GAIN_TYPE_FAILURE'

const UPDATE_GAIN_TYPE_REQUEST = 'Reward/UPDATE_GAIN_TYPE_REQUEST'
const UPDATE_GAIN_TYPE_SUCCESS = 'Reward/UPDATE_GAIN_TYPE_SUCCESS'
const UPDATE_GAIN_TYPE_FAILURE = 'Reward/UPDATE_GAIN_TYPE_FAILURE'

const DELETE_REWARD_REQUEST = 'Reward/DELETE_REWARD_REQUEST'
const DELETE_REWARD_SUCCESS = 'Reward/DELETE_REWARD_SUCCESS'
const DELETE_REWARD_FAILURE = 'Reward/DELETE_REWARD_FAILURE'

const FETCH_COUPON_REPORT_REQUEST = 'Reward/FETCH_COUPON_REPORT_REQUEST'
const FETCH_COUPON_REPORT_SUCCESS = 'Reward/FETCH_COUPON_REPORT_SUCCESS'
const FETCH_COUPON_REPORT_FAILURE = 'Reward/FETCH_COUPON_REPORT_FAILURE'

const FETCH_USER_POINT_SEARCH_REQUEST = 'Reward/FETCH_USER_POINT_SEARCH_REQUEST'
const FETCH_USER_POINT_SEARCH_SUCCESS = 'Reward/FETCH_USER_POINT_SEARCH_SUCCESS'
const FETCH_USER_POINT_SEARCH_FAILURE = 'Reward/FETCH_USER_POINT_SEARCH_FAILURE'

const FETCH_POINT_SCOPE_REQUEST = 'Reward/FETCH_POINT_SCOPE_REQUEST'
const FETCH_POINT_SCOPE_SUCCESS = 'Reward/FETCH_POINT_SCOPE_SUCCESS'
const FETCH_POINT_SCOPE_FAILURE = 'Reward/FETCH_POINT_SCOPE_FAILURE'

const GRANT_POINT_REQUEST = 'Reward/GRANT_POINT_REQUEST'
const GRANT_POINT_SUCCESS = 'Reward/GRANT_POINT_SUCCESS'
const GRANT_POINT_FAILURE = 'Reward/GRANT_POINT_FAILURE'

const DELETE_REWARD_CONDITION_REQUEST = 'Reward/DELETE_REWARD_CONDITION_REQUEST'
const DELETE_REWARD_CONDITION_SUCCESS = 'Reward/DELETE_REWARD_CONDITION_SUCCESS'
const DELETE_REWARD_CONDITION_FAILURE = 'Reward/DELETE_REWARD_CONDITION_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  rewardList: [],
  couponReport: { summary: {}, items: [] },
  pointScopeList: [],
  userPointSearchList: [],
  condition: [],
  userRedeemList: [],
  userPointList: [],
  pointGainList: [],
  gainPointTypeList: [],
  pointRemoveList: [],
  pointRedeemList: []
}

// Default Reducer
const reward = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_POINT_SEARCH_SUCCESS:
      return { ...state, userPointSearchList: action.payload }
    case FETCH_POINT_SCOPE_SUCCESS:
      return { ...state, pointScopeList: action.payload }
    case FETCH_COUPON_REPORT_REQUEST:
      return { ...state, isLoading: true }
    case FETCH_COUPON_REPORT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        couponReport: {
          summary: {
            issued: action.payload.issued,
            used: action.payload.used,
            expiredUnopened: action.payload.expiredUnopened,
            breakageRate: action.payload.breakageRate
          },
          items: action.payload.items || []
        }
      }
    case FETCH_COUPON_REPORT_FAILURE:
      return { ...state, isLoading: false }
    case FETCH_REWARD_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_REWARD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        rewardList: action.payload
      }
    case FETCH_REWARD_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_REWARD_CONDITION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_REWARD_CONDITION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        condition: action.payload
      }
    case FETCH_REWARD_CONDITION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_POINT_GAIN_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_POINT_GAIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pointGainList: action.payload
      }
    case FETCH_POINT_GAIN_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_POINT_REMOVE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_POINT_REMOVE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pointRemoveList: action.payload
      }
    case FETCH_POINT_REMOVE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_POINT_REDEEM_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_POINT_REDEEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pointRedeemList: action.payload
      }
    case FETCH_POINT_REDEEM_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_GAIN_TYPE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_GAIN_TYPE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        gainPointTypeList: action.payload
      }
    case FETCH_GAIN_TYPE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_USER_REDEEM_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_USER_REDEEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userRedeemList: action.payload
      }
    case FETCH_USER_REDEEM_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_USER_POINT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_USER_POINT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userPointList: action.payload
      }
    case FETCH_USER_POINT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_REWARD_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_REWARD_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_REWARD_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_REWARD_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_REWARD_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_REWARD_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_REWARD_CONDITION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_REWARD_CONDITION_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_REWARD_CONDITION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_REWARD_CONDITION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_REWARD_CONDITION_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_REWARD_CONDITION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_USER_REDEEM_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_USER_REDEEM_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_USER_REDEEM_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_POINT_REMOVE_REASONS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_POINT_REMOVE_REASONS_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_POINT_REMOVE_REASONS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_GAIN_TYPE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_GAIN_TYPE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_GAIN_TYPE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_GAIN_TYPE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_GAIN_TYPE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_GAIN_TYPE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_REWARD_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_REWARD_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_REWARD_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_REWARD_CONDITION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_REWARD_CONDITION_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_REWARD_CONDITION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }

    default:
      return state
  }
}

export default reward

// Action Creators
export const fetchRewardList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_REWARD_REQUEST
      })

      const response = await API.get(EndPoints.REWARD + `/getAll`)
      dispatch({
        type: FETCH_REWARD_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_REWARD_FAILURE
      })
    }
  }
}

export const fetchConditionList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_REWARD_CONDITION_REQUEST
      })

      const response = await API.get(EndPoints.REWARD + `/getConditionAll`)
      dispatch({
        type: FETCH_REWARD_CONDITION_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_REWARD_CONDITION_FAILURE
      })
    }
  }
}

export const fetchGainTypeList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_GAIN_TYPE_REQUEST
      })

      const response = await API.get(EndPoints.REWARD + `/admin/getAllGainPointType`)
      dispatch({
        type: FETCH_GAIN_TYPE_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_GAIN_TYPE_FAILURE
      })
    }
  }
}

export const getAllPointGain = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_POINT_GAIN_REQUEST
      })

      const response = await API.get(EndPoints.REWARD + `/searchUserGainPointTransaction`, {
        params: options
      })
      dispatch({
        type: FETCH_POINT_GAIN_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_POINT_GAIN_FAILURE
      })
    }
  }
}
export const getAllPointRemove = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_POINT_REMOVE_REQUEST
      })

      const response = await API.get(EndPoints.REWARD + `/searchUserRemovePointTransaction`, {
        params: options
      })
      dispatch({
        type: FETCH_POINT_REMOVE_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_POINT_REMOVE_FAILURE
      })
    }
  }
}
export const getAllPointRedeem = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_POINT_REDEEM_REQUEST
      })

      const response = await API.get(EndPoints.REWARD + `/searchUserRedeemPointTransaction`, {
        params: options
      })
      dispatch({
        type: FETCH_POINT_REDEEM_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_POINT_REDEEM_FAILURE
      })
    }
  }
}
export const updatePointRemoveReason = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_POINT_REMOVE_REASONS_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.REWARD + `/admin/updatePointRemoveReason`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_POINT_REMOVE_REASONS_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_POINT_REMOVE_REASONS_FAILURE
      })
    }
  }
}
export const createPointGainType = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_GAIN_TYPE_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.REWARD + `/admin/createGainPointType`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_GAIN_TYPE_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_GAIN_TYPE_FAILURE
      })
    }
  }
}

export const updatePointGainType = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_GAIN_TYPE_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.REWARD + `/admin/updatePointGainType`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_GAIN_TYPE_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_GAIN_TYPE_FAILURE
      })
    }
  }
}
export const fetchUserRedeemList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_USER_REDEEM_REQUEST
      })

      const response = await API.get(EndPoints.REWARD + `/admin/redeemHistory`)
      dispatch({
        type: FETCH_USER_REDEEM_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_USER_REDEEM_FAILURE
      })
    }
  }
}

export const fetchUserPointList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_USER_POINT_REQUEST
      })

      const response = await API.get(EndPoints.REWARD + `/admin/getAllUserPoint`)
      dispatch({
        type: FETCH_USER_POINT_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_USER_POINT_FAILURE
      })
    }
  }
}

export const createRewardCondition = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_REWARD_CONDITION_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.REWARD + `/createRewardCondition`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_REWARD_CONDITION_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_REWARD_CONDITION_FAILURE
      })
    }
  }
}

export const updateRewardCondition = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_REWARD_CONDITION_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.REWARD + `/updateRewardCondition`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_REWARD_CONDITION_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_REWARD_CONDITION_FAILURE
      })
    }
  }
}
export const fetchCouponReport = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_COUPON_REPORT_REQUEST })
      const response = await API.get('/coupon/admin/report')
      dispatch({ type: FETCH_COUPON_REPORT_SUCCESS, payload: response.data })
    } catch (err) {
      dispatch({ type: FETCH_COUPON_REPORT_FAILURE })
    }
  }
}

export const fetchPointScopeList = (keyword) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_POINT_SCOPE_REQUEST })
      const response = await API.get(EndPoints.REWARD + `/admin/point-scope`, {
        params: { keyword: keyword || '', page: 0, size: 30 }
      })
      dispatch({ type: FETCH_POINT_SCOPE_SUCCESS, payload: response.data })
    } catch (err) {
      dispatch({ type: FETCH_POINT_SCOPE_FAILURE })
    }
  }
}

/** ค้นหาผู้ใช้จาก server — ผู้ใช้หลักหมื่น โหลดทั้งหมดมากรองฝั่ง client ไม่ไหว */
export const searchUserPoint = (keyword) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_USER_POINT_SEARCH_REQUEST })
      const response = await API.get(EndPoints.REWARD + `/admin/searchUserPoint`, {
        params: { keyword: keyword || '', page: 0, size: 30 }
      })
      dispatch({
        type: FETCH_USER_POINT_SEARCH_SUCCESS,
        payload: response.data.content || []
      })
    } catch (err) {
      dispatch({ type: FETCH_USER_POINT_SEARCH_FAILURE })
    }
  }
}

export const grantPointManually = (data) => {
  return async (dispatch) => {
    dispatch({ type: GRANT_POINT_REQUEST })
    try {
      const response = await API.post(EndPoints.REWARD + `/admin/grantPoint`, data, {
        headers: { 'Content-Type': 'application/json' }
      })
      dispatch({ type: GRANT_POINT_SUCCESS })
      return response.data
    } catch (err) {
      dispatch({ type: GRANT_POINT_FAILURE })
      throw err
    }
  }
}

export const createReward = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_REWARD_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.REWARD + `/createReward`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_REWARD_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_REWARD_FAILURE
      })
    }
  }
}

export const updateReward = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_REWARD_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.REWARD + `/updateReward`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_REWARD_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_REWARD_FAILURE
      })
    }
  }
}
export const updateUserRedeemReward = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_USER_REDEEM_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.REWARD + `/admin/updateRedeemReward`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_USER_REDEEM_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_USER_REDEEM_FAILURE
      })
    }
  }
}

export const deleteReward = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_REWARD_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.REWARD + `/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_REWARD_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_REWARD_FAILURE
      })
    }
  }
}
export const deleteRewardCondition = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_REWARD_CONDITION_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      const response = await API.delete(EndPoints.REWARD + `/condition/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_REWARD_CONDITION_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error('ไม่สามารถลบได้เนื่องจากมี Reward ใช้ Condition นี้อยู่')
      dispatch({
        type: DELETE_REWARD_CONDITION_FAILURE
      })
    }
  }
}





